/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Organizationsettings_Invitedas2Inputs */

const zh_organizationsettings_invitedas2 = /** @type {(inputs: Organizationsettings_Invitedas2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`邀请为${i?.role}`)
};

const en_organizationsettings_invitedas2 = /** @type {(inputs: Organizationsettings_Invitedas2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invited as ${i?.role}`)
};

const es_organizationsettings_invitedas2 = /** @type {(inputs: Organizationsettings_Invitedas2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitado como ${i?.role}`)
};

/**
* | output |
* | --- |
* | "Invited as {role}" |
*
* @param {Organizationsettings_Invitedas2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_invitedas2 = /** @type {((inputs: Organizationsettings_Invitedas2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Invitedas2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_invitedas2(inputs)
	if (locale === "en") return en_organizationsettings_invitedas2(inputs)
	return es_organizationsettings_invitedas2(inputs)
});
export { organizationsettings_invitedas2 as "organizationSettings_invitedAs" }